export default __webpack_public_path__ + "static/media/flashingarc9.3b7598bc.png";